import * as React from 'react';
import { Localize } from "shared/utils/localization";
import { PairingStore, EPairingState } from '../pairingstore';
import { BottomButton, BottomButtons } from '../pairing';

export enum EDevicePairingState
{
	Uninitialized,
	ShowInstructions,
	Searching,
	Timeout,
	Success,
	Success_NoMoreDongles,
}

interface CPairingDeviceState
{
	pairingState: EDevicePairingState;
}

export class CPairingDevice extends React.Component<{}, CPairingDeviceState>
{
	constructor( props?: any )
	{
		super( props );

		this.state = {
			pairingState: EDevicePairingState.ShowInstructions,
		};
	}

	public get className(): string
	{
		return "Uninitialized";
	}

	public get aControllerName(): string
	{
		return "an Uninitialized";
	}

	public get controllerName(): string
	{
		return "Uninitialized";
	}

	public renderControllerImage( bHighlightPairingControls: boolean ): JSX.Element
	{
		return ( <div className="PairingImagePlaceholder"></div> );
	}

	protected get pairingInstructions(): JSX.Element
	{
		return (
			<div>
				<p>{ Localize( "#pairinginstructions_generic_desc" ) }</p>
			</div>
		);
	}

	protected renderInstructions(): JSX.Element
	{
		return (
			<div className={ "PairingDevice " + this.className }>
				<div className="Label Title">{ Localize( "#pair_controller_title", this.aControllerName ) }</div>
				<div className="PairingImage">
					{ this.renderControllerImage( true ) }
				</div>
				<div className="PageContent PairingInstructions HalfWidth">
					<div className="Label">{ this.pairingInstructions }</div>
				</div>
				<BottomButtons>
					<BottomButton onClick={ () => PairingStore.ChooseController() } text={ Localize( '#pairing_button_differentcontroller' ) } />
				</BottomButtons>
			</div>
		);
	}

	protected renderSuccess(): JSX.Element
	{
		return (
			<div className={ "PairingDevice " + this.className }>
				<div className="Label Title">{ Localize( "#pairsuccess_title" ) }</div>
				<div className="PairingImage">
					{ this.renderControllerImage( true ) }
				</div>
				<div className="PageContent">
					<img className="StatusIcon" src="/lighthouse/webinterface/images/pairingui/icon_success.svg" />
					<div className="Label">{ Localize( "#pairsuccess_desc" ) }</div>
				</div>
				<BottomButtons>
					<BottomButton onClick={ PairingStore.PairWithFreeDongle } text={ Localize( '#pairing_success_again' ) } focus={ true } />
					<BottomButton onClick={ PairingStore.Close } text={ Localize( '#pairing_button_done' ) } />
				</BottomButtons>
			</div>
		);
	}

	protected renderTimedOut(): JSX.Element
	{
		return (
			<div className={ "PairingDevice " + this.className }>
				<div className="Label Title">{ Localize( "#pairing_error_title" ) }</div>
				<div className="PairingImage">
					{ this.renderControllerImage( true ) }
				</div>
				<div className="PageContent">
					<img className="StatusIcon" src="/lighthouse/webinterface/images/pairingui/icon_not_detected.svg" />
					<div className="Label">{ Localize( "#pairing_timed_out_desc" ) }</div>
				</div>
				<BottomButtons>
					<BottomButton onClick={ PairingStore.PairWithFreeDongle } text={ Localize( '#pairing_try_again' ) } focus={ true } />
					<BottomButton onClick={ PairingStore.Close } text={ Localize( '#pairing_button_cancel' ) } />
				</BottomButtons>
			</div>
		);
	}

	public render(): JSX.Element
	{
		switch ( PairingStore.pairingState )
		{
			case EPairingState.WaitingForDeviceToPair:
				return this.renderInstructions();
			case EPairingState.UpdatingDongleListAfterPairing:
			case EPairingState.Success:
				return this.renderSuccess();
			case EPairingState.TimedOut:
				return this.renderTimedOut();
			default:
				console.error( "CPairingDevice.render(): Invalid pairing state: " + EPairingState[PairingStore.pairingState] );
				return ( <div> Invalid pairing state. </div> );
		}

	}

}
